<template>
  <div class="lesson-footer">
    <template v-if="status === 'NOTICE'">
      <div class="btn" @click="doReminder(product.code)">
        {{remind ? '已开启报名提醒' : '开始报名提醒我'}}
      </div>
    </template>
    <template v-else-if="status === 'REGISTER'">
      <div class="btn" @click="jump" v-if="product.stock.left > 0">还剩{{product.stock.left}}个名额，立即报名</div>
      <div class="btn over" v-else>来晚了，名额已满</div>
    </template>
    <template v-else-if="status === 'OVER'">
      <div class="btn over">已结束</div>
    </template>
  </div>
</template>

<script>
import bridge from '@beastshop/bridge'
import browser from '@beastshop/browser'

import {
  reminderLesson,
  cancelReminderLesson
} from '../../api'

const ENUM_NAME = ['注册会员', '松鼠会员', '小猫会员', '老虎会员', '大象会员', '兔子会员']

let _pedding = false

export default {
  props: {
    product: Object,
    sdk: Object,
    env: String
  },

  data () {
    return {
      status: '',
      vipLevel: [],
      remind: false
    }
  },

  created () {
    this.status = this.product.status
    this.remind = this.product.remind
    this.vipLevel = this.product.vipLevel
  },

  methods: {
    jump () {
      if (_pedding) return

      _pedding = true
      this.login()
      .then(member => {
        const level = member.level.id

        if (this.vipLevel.indexOf(level+"") === -1) {
          let str = ''

          this.vipLevel.forEach(id => {
            str += ENUM_NAME[id - 0 + 1] + ' '
          })

          this.$alert(`此课程仅限${str}报名`)
          _pedding = false
          return
        }

        if (!this.product.allowOnlyCash && !this.checkPoint(member.point)) {
          this.$alert('积分不足，请先去购物获取积分')
          _pedding = false
          return
        }

        let linkData = {
          url: `/beast/lesson/variant?productId=${this.product.productCode}`,
          mpType: 'web'
        } 

        switch (this.env) {
          case 'app':
            linkData.url = `beastapp://entry?name=beast-lesson-variant&productId=${this.product.productCode}`
            break
        }
        
        _pedding = false
        this.sdk.navigate.jumpTo(linkData)
      })
    },

    checkPoint (memPoint) {
      const { 
        times
      } = this.product
      
      let pass = false
      
      times.forEach(time => {
        if (time.price.point <= memPoint) {
          pass = true
        }
      })
      
      return pass
    },

    doReminder (courseCode) {
      this.$ensureLogged()
      .then(() => {
        if (this.remind) {
          cancelReminderLesson(courseCode)
          .then(({ data }) => {
            this.remind = false

            this.$toast('报名提醒已关闭')
          })
        }
        else {
          reminderLesson(courseCode)
          .then(({ data }) => {
            this.remind = true

            this.$toast('报名提醒已开启，报名开始时会短信通知你，注意查收哦！')
          })
        }
      })
    },

    login () {
      return new Promise((resolve, reject) => {
        this.sdk.ensureLogged()
        .then(({ member }) => {
          switch (this.env) {
            case 'app':
              bridge.getMember()
              .then(member => {
                resolve(member)
              })
              break
            case 'miniprogram':
              this.sdk.getMember()
              .then(member => {
                resolve(member)
              })
              break
            default: 
              resolve(member)
          }
        })
      })
    }
  }
}
</script>

<style lang="stylus">

</style>




// WEBPACK FOOTER //
// footer.vue?1c20406e